import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { down } from 'styled-breakpoints';

const LIST_ITEM_TILE_SIZE = 32;

// helpers

const flexColumnStyles = (arg?: { gap?: string }) => css`
  display: flex;
  flex-direction: column;
  gap: ${arg?.gap ?? 0};
`;

const flexRowStyles = (arg?: { gap?: string }) => css`
  display: flex;
  flex-direction: row;
  gap: ${arg?.gap ?? 0};
`;

// confirm modal styles

export const ModalBodyText = styled.p`
  margin: 0;
  font: var(--font-regular-14pt-normal);
  color: var(--color-grayscale-black);
  padding: 32px;
  text-align: center;
`;

export const ModalButtonWrapper = styled.div`
  ${flexRowStyles()}
  justify-content: space-between;
`;

// Side content styles

export const SideContentContainer = styled.div`
  width: 400px;
  height: 100%;
  overflow-y: auto;
  border: 1px solid var(--color-gray-20);
  border-radius: 12px;
  flex-shrink: 0; /* Prevent width from shrinking */
  ${flexColumnStyles()}

  ${down('smallDesktop')} {
    width: 100%; /* Take full width when stacked */
  }
`;

export const SideContentHeader = styled.div`
  padding: var(--sizes-40);
  ${flexRowStyles({ gap: 'var(--sizes-50)' })}
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--color-gray-20);
  font: var(--font-large-16pt-semibold);
  color: var(--color-grayscale-black);
`;

export const SideContentBody = styled.div`
  padding: 24px;
  ${flexColumnStyles({ gap: 'var(--sizes-70)' })}
`;

export const SideContentBodyText = styled.p`
  font: var(--font-regular-14pt-normal);
  color: var(--color-gray-90);
  margin: 0;
`;

export const SideContentListContainer = styled.div`
  ${flexColumnStyles({ gap: 'var(--sizes-70)' })}
`;

export const SideContentListSection = styled.div`
  ${flexColumnStyles({ gap: 'var(--sizes-40)' })}
`;

export const ListTitle = styled.p`
  font: var(--font-regular-14pt-semibold);
  margin: 0;
`;

export const List = styled.ul`
  ${flexColumnStyles({ gap: 'var(--sizes-40)' })}
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const ListItem = styled.li`
  ${flexRowStyles({ gap: 'var(--sizes-40)' })}
  align-items: flex-start;
  font: var(--font-regular-14pt-normal);
  color: var(--color-gray-90);
  margin: 0;
`;

export const IconTile = styled.div`
  ${flexColumnStyles()}
  align-items: center;
  justify-content: center;
  width: ${LIST_ITEM_TILE_SIZE}px;
  height: ${LIST_ITEM_TILE_SIZE}px;
  border-radius: 6.4px;
  background: var(--color-gray-20);
  flex-shrink: 0;
`;

export const ListItemContent = styled.div`
  ${flexColumnStyles({ gap: '4px' })}
`;

export const ListItemTitle = styled.span`
  font-weight: var(--font-weight-semibold);
`;

export const ListItemText = styled.span`
  font: var(--font-small-13pt-normal);
`;
